import { FieldValues } from 'react-hook-form';
import {
  AutocompleteElementProps,
  AutocompleteElement,
} from 'react-hook-form-mui';
import { Lookup } from '@/types';
import { useTranslation } from 'react-i18next';

export function YesNoAutocompleteElement<TFieldValues extends FieldValues>({
  textFieldProps,
  name,
  control,
  loading,
  showCheckbox,
  rules,
  required,
  multiple,
  matchId,
  label,
}: Omit<
  AutocompleteElementProps<
    TFieldValues,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    string | any,
    boolean | undefined,
    boolean | undefined
  >,
  'options'
>) {
  const { t } = useTranslation();

  const yes_no: Lookup[] = [
    { id: 'true', label: t('Yes') },
    { id: 'false', label: t('No') },
  ];

  return (
    <AutocompleteElement
      textFieldProps={textFieldProps}
      name={name}
      control={control}
      options={yes_no}
      loading={loading}
      showCheckbox={showCheckbox}
      rules={rules}
      required={required}
      multiple={multiple}
      matchId={matchId}
      label={label}
    />
  );
}
